import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Measuring vocabulary richness with python",
  "description": "",
  "published": "2011-09-28T00:00:00.000Z",
  "redirect_from": ["/blog/measuring-vocabulary-richness-with-python/swizec/2528"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/6192586527_c36407222c_m7.jpg",
        "alt": "Pillowfights 51",
        "title": "Pillowfights 51"
      }}></img></p>
    <p>{`In preparation for a blogpost I'm going to make some time this week I found myself wanting to somehow parametrize `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Vocabulary",
        "title": "Vocabulary"
      }}>{`vocabulary`}</a>{` richness in a piece of text.`}</p>
    <p><em parentName="p">{`btw, Code at bottom ;)`}</em></p>
    <p>{`It's an interesting problem because when you read something, it's pretty easy to see when an author is using rich vocabulary, but trying to reduce this observation to a simple number turns out to be a bit of a brainfuck. It's obviously somehow related to word frequencies and it seems obvious that what we want to measure is the distribution shape of word frequencies.`}</p>
    <p>{`Luckily googling around for about an hour turned up a clue. Way back in 1944 a statistician called `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Udny_Yule"
      }}>{`G.U. Yule`}</a>{` cracked this problem in a paper titled `}<em parentName="p"><a parentName="em" {...{
          "href": "http://scholar.google.si/scholar?q=The+statistical+study+of+literary+vocabulary+&hl=sl&btnG=Iskanje"
        }}>{`The statistical study of literary vocabulary`}</a></em>{`. What he came up with is the so called Yule's K characteristic.`}</p>
    <p>{`Wikipedia is scarce on these things, so we know we're treading strange strange ground here. Persistent searching with google scholar turned up a version of the paper that wasn't paywalled to oblivion. However since it was on google books it was missing some key pages.`}</p>
    <p>{`Luckily what looks like a random homework for R explains perfectly how to implement Yule's K value:`}</p>
    <blockquote>
      <p parentName="blockquote">{`A complementary way of assessing the vocabulary difficulty of texts is to measure their lexical richness. Two indices one could use are Yule's K or Yule's I. These two are defined as follows: (1) Yule's K = 10,000⋅M 2−M 1 ÷ M 1⋅M 1 (2) Yule's I = M 1⋅M 1÷M 2−M 1  where M1 is the number of all word forms a text consists of and M2 is the sum of the products of each observed frequency to the power of two and the number of word types observed with that frequency (cf. Oakes 1998:204). For example, if one word occurs three times and four words occur five times, M2=(1`}{`*`}{`32)+(4`}{`*`}{`52)=109. The larger Yule's K, the smaller the diversity of the vocabulary (and thus, arguably, the easier the text). Since Yule's I is based on the reciprocal of Yule's K, the larger Yule's I, the larger the diversity of the vocabulary (and thus, arguably, the more difficult the text).`}</p>
    </blockquote>
    <p>{`Unfortunately I don't have the link anymore. It was a seriously random pdf I found online, the title seems to be `}<em parentName="p">{`"Quantitative `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Corpus_linguistics",
          "title": "Corpus linguistics"
        }}>{`corpus linguistics`}</a>{` with R: a practical introduction"`}</em></p>
    <p>{`In hopes this blogpost saves somebody a few hours of googling when trying to measure vocabulary richness, here's my python implementation of Yule's K characteristic (or rather its inverse, Yule's I)`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from nltk.stem.porter import PorterStemmer
from itertools import groupby

def words(entry):
    return filter(lambda w: len(w) > 0,
                  [w.strip("0123456789!:,.?(){}[]") for w in entry.split()])

def yule(entry):
    # yule's I measure (the inverse of yule's K measure)
    # higher number is higher diversity - richer vocabulary
    d = {}
    stemmer = PorterStemmer()
    for w in words(entry):
        w = stemmer.stem(w).lower()
        try:
            d[w] += 1
        except KeyError:
            d[w] = 1

    M1 = float(len(d))
    M2 = sum([len(list(g))*(freq**2) for freq,g in groupby(sorted(d.values()))])

    try:
        return (M1*M1)/(M2-M1)
    except ZeroDivisionError:
        return 0
`}</code></pre>
    <p>{`For example the output of that function for this post is 21.6`}</p>
    <p>{`Just wish I knew how to make that middle part more functional-like. I don't like having weird for loops strewn about my code like that.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.makeuseof.com/tag/improve-english-learn-words-vocabularycom/"
        }}>{`Improve Your English & Learn New Words With Vocabulary.com`}</a>{` (makeuseof.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://annmic.wordpress.com/2011/09/20/vocabulary-building/"
        }}>{`Vocabulary Building`}</a>{` (annmic.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.education.com/worksheets/vocabulary/"
        }}>{`Vocabulary Worksheets and Printables`}</a>{` (education.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=6825c36b-0d62-4d69-a0eb-3b4d98c62cad",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      